import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FormControl, FormGroup } from '@cancercentrum/rcc-bootstrap';
import omit from 'lodash/omit';
import debounce from 'lodash/debounce';
export const CustomMenu = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, searchable, className, onFilterKeyDown, defaultFilter, filterDebounce, ...rest } = props;
    const [filter, setFilter] = useState(defaultFilter || '');
    const inputElement = useRef(null);
    const propsRef = useRef(props);
    const triggerOnFilterChange = useMemo(()=>{
        const fn = (f)=>{
            propsRef.current.onFilterChange(f);
        };
        return filterDebounce ? debounce(fn, filterDebounce) : fn;
    }, [
        filterDebounce
    ]);
    propsRef.current = props;
    useEffect(()=>{
        if (inputElement && inputElement.current) {
            if (propsRef.current.setInputElement) {
                propsRef.current.setInputElement(inputElement.current);
            }
            inputElement.current.focus();
            inputElement.current.select();
        }
    }, []);
    const onChange = (e)=>{
        setFilter(e.target.value);
        triggerOnFilterChange(e.target.value);
    };
    return(// @ts-ignore propsen som definieras i DropdownMenuProps hanteras av DropdownMenu-komponenten, och skickas aldrig vidare.
    /*#__PURE__*/ _jsxs("div", {
        className: className,
        ref: ref,
        ...omit(rest, [
            'close',
            'alignRight',
            'show',
            'onFilterChange',
            'setInputElement'
        ]),
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: searchable && /*#__PURE__*/ _jsx(FormGroup, {
                    className: "filter",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "mx-3 my-2",
                        children: /*#__PURE__*/ _jsx(FormControl, {
                            ref: inputElement,
                            onKeyDown: onFilterKeyDown,
                            onChange: onChange,
                            value: filter,
                            autoComplete: "off",
                            type: "search",
                            icon: faSearch
                        })
                    })
                })
            }),
            children
        ]
    }));
});
CustomMenu.displayName = 'DropdownListMenu';
